import Integration from './Integration';

export default class ChatweeIntegration extends Integration {
	constructor(integration) {
		super(integration);

		this.chatId = integration.chat_id;
	}
}
